import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

const CANTON_CODES = [
  'ag',
  'ai',
  'ar',
  'be',
  'bl',
  'bs',
  'fr',
  'ge',
  'gl',
  'gr',
  'ju',
  'lu',
  'ne',
  'nw',
  'ow',
  'sg',
  'sh',
  'so',
  'sz',
  'tg',
  'ti',
  'ur',
  'vd',
  'vs',
  'zg',
  'zh',
];

@Pipe({
  name: 'canton',
  standalone: true,
  // Impur : le libellé du canton dépend de la langue active.
  pure: false,
})
export class CantonPipe implements PipeTransform {
  private translocoService = inject(TranslocoService);

  transform(value: string): string {
    if (!value || !CANTON_CODES.includes(value.toLowerCase())) {
      return value;
    }

    return this.translocoService.translate(`common.canton.${value.toLowerCase()}`);
  }
}
